<template>
  <div class="add-form">
    <Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
      <FormItem label="类型" prop="type">
        <RadioGroup v-model="form.type">
          <Radio label="1">页面</Radio>
          <Radio label="2">接口</Radio>
          <Radio label="3">按钮</Radio>
        </RadioGroup>
      </FormItem>
      <template v-if="form.type == 1">
        <FormItem label="是否菜单" prop="is_menu">
          <RadioGroup v-model="form.is_menu">
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </FormItem>
      </template>
      <FormItem label="父级菜单" prop="partner_id">
        <Cascader :data="apiData.partnerMenu" v-model="form.partner_id" style="width: 400px"></Cascader>
      </FormItem>

      <!-- 菜单类型 -->
      <template v-if="form.type == 1">
        <FormItem label="菜单名称" prop="name">
          <Input placeholder="请输入菜单名称" v-model="form.name" style="width: 400px"></Input>
        </FormItem>
        <FormItem label="菜单路由" prop="slug">
          <Input placeholder="请输入菜单路由" v-model="form.slug" style="width: 400px"></Input>
        </FormItem>
        <FormItem label="菜单图标" prop="menu_icon">
          <Icon v-if="form.menu_icon != ''" :type="form.menu_icon" size="28" style="margin-right: 10px" />
          <Button type="primary" @click="diyDom.showIcon = true">选择图标</Button>
        </FormItem>
        <FormItem label="菜单排序" prop="sort">
          <Input placeholder="请输入菜单排序" v-model="form.sort" style="width: 400px"></Input>
        </FormItem>
      </template>
      <!-- 按钮类型 -->
      <template v-else-if="form.type == 2">
        <FormItem label="接口名称" prop="name">
          <Input placeholder="请输按钮名称" v-model="form.name" style="width: 400px"></Input>
        </FormItem>
        <FormItem label="接口路径" prop="slug">
          <Input placeholder="请输接口路径" v-model="form.slug" style="width: 400px"></Input>
        </FormItem>
        <FormItem label="请求方式" prop="type">
          <Select v-model="form.http_method" style="width: 400px" placeholder="请选择请求方式">
            <Option v-for="(item, index) in diyData.httpMethod" :label="item" :value="item" :key="index"></Option>
          </Select>
        </FormItem>
      </template>
      <!-- 按钮类型 -->
      <template v-else-if="form.type == 3">
        <FormItem label="按钮名称" prop="name">
          <Input placeholder="请输按钮名称" v-model="form.name" style="width: 400px"></Input>
        </FormItem>
        <FormItem label="按钮标识" prop="slug">
          <Input placeholder="请输按钮标识" v-model="form.slug" style="width: 400px"></Input>
        </FormItem>
      </template>
      <FormItem label="状态" prop="status">
        <RadioGroup v-model="form.status">
          <Radio label="1">有效</Radio>
          <Radio label="0">无效</Radio>
        </RadioGroup>
      </FormItem>
    </Form>
    <Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
    <Button style="width: 90px" @click="$router.go(-1)">取消</Button>

    <!-- 选择图标 -->
    <edit-icon v-model="diyDom.showIcon" :defaultIcon="form.menu_icon" @on-success="iconSuccess"></edit-icon>
  </div>
</template>

<script>
  import _ from 'lodash'
  import * as apiPermission from '@/api/permission/permission'
  import editIcon from './edit-icon.vue'
  export default {
    name: 'add-permission-name',
    components: {
      editIcon,
    },
    data() {
      return {
        query: {},
        search: {},
        diyDom: {
          showIcon: false,
        },
        // 表单数据
        form: {
          name: '', // 权限名称
          menu_icon: '', // 图标
          http_method: '', // 请求方式
          sort: 1, // 排序
          slug: '', // 请求路径/菜单路由/按钮标识
          type: '1', // 权限类型1页面（菜单）2接口3按钮
          partner_id: [], // 父级菜单
          is_menu: '1', // 是否是菜单
          status: '1', // 状态
        },
        diyData: {
          httpMethod: ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'],
          rules: {
            type: [{ required: true, message: '类型不能为空', trigger: 'change' }],
            name: [{ required: true, message: '名称为空', trigger: 'blur' }],
            http_method: [{ required: true, message: '请求方式不能为空', trigger: 'change' }],
            slug: [{ required: true, message: '标识不能为空', trigger: 'blur' }],
            is_menu: [{ required: true, message: '是否菜单不能为空', trigger: 'change' }],
            status: [{ required: true, message: '状态不能为空', trigger: 'change' }],
          },
        },
        apiData: {
          partnerMenu: [],
        },
      }
    },
    computed: {},
    methods: {
      // 获取上级菜单
      getPartnerMenu() {
        apiPermission.apiPartnerMenu().then(res => {
          let list = this.iterationFn(res.data)
          this.apiData.partnerMenu = this.copyWithChildren(list)
        })
      },
      // 迭代函数
      iterationFn(arr) {
        return arr.map(item => {
          return {
            ...item,
            value: item.id,
            label: item.name,
            children: item.children ? this.iterationFn(item.children) : [],
          }
        })
      },
      // 设置同级子级菜单
      copyWithChildren(data) {
        const result = []
        for (let i = 0; i < data.length; i++) {
          let item = data[i]
          // 复制当前对象到 children 中
          if (item.children && item.children.length > 0) {
            let obj = _.cloneDeep(item)
            delete obj.children
            result.push(obj)
            item.children = this.copyWithChildren(item.children)
          }
          // 将当前对象添加到 result 数组中
          result.push(item)
        }
        return result
      },

      // 选择图标
      iconSuccess(icon) {
        this.form.menu_icon = icon
      },
      // 获取详情
      getDetail() {
        this.$store.commit('setSpinShow', true)
        apiPermission
          .apiPermissionDetail(this.query.id)
          .then(res => {
            this.form.name = res.data.name
            this.form.menu_icon = res.data.menu_icon
            this.form.http_method = res.data.http_method
            this.form.sort = res.data.sort
            this.form.slug = res.data.slug
            this.form.type = res.data.type + ''
            this.form.is_menu = res.data.is_menu + ''
            this.form.status = res.data.status + ''
            this.form.partner_id = res.data.partner_id.map(item => item)
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },
      submit() {
        this.$refs['addForm'].validate(valid => {
          if (valid) {
            const opt = _.cloneDeep(this.form)
            this.$store.commit('setSpinShow', true)
            if (this.query.id) {
              opt.id = this.query.id
              apiPermission
                .apiPermissionUpdate(this.query.id, opt)
                .then(res => {
                  this.$Message.success('编辑权限成功')
                  this.$router.go(-1)
                })
                .finally(() => this.$store.commit('setSpinShow', false))
            } else {
              apiPermission
                .apiPermissionAdd(opt)
                .then(res => {
                  this.$Message.success('添加权限成功')
                  this.$router.go(-1)
                })
                .finally(() => this.$store.commit('setSpinShow', false))
            }
          }
        })
      },
    },
    watch:{
      "form.type"(val) {
        if(val != 1) {
          this.form.is_menu = '0'
        }
      }
    },
    mounted() {
      this.query = this.$route.query
      this.getPartnerMenu()
      this.query.id && this.getDetail()
    },
  }
</script>

<style scoped lang="less">
  .add-form {
    border: 1px solid #ededed;
    margin: 0 20px;
    padding: 26px 20px;

    .title {
      border-left: 5px solid #2d8cf0;
      padding: 0 0 0 10px;
      margin: 0 20px 20px;
      font-weight: bold;
    }
  }
</style>
